import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const SalesRegionInput = () => {
  const { regionId = '' } = useParams();
  const decodedId = regionId ? atob(regionId) : regionId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'salesRegion';

  useEffect(() => {
    if (regionId) { setIsEditing(true); fetchDetails(); }
  }, [regionId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['salesRegion'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Sales Region details:', error); }
  };

  const fields = [
    { name: 'name', label: 'Region Name', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'country', label: 'Country', type: 'text' },
    { name: 'territory_code', label: 'Territory Code', type: 'text' },
    { name: 'headquarters_city', label: 'Headquarters City', type: 'text' },
    {
      name: 'region_manager', label: 'Region Manager', type: 'async-select',
      endpoint: API_ROUTES.users,
      getOptionLabel: (u) => u.username,
    },
    { name: 'target_revenue', label: 'Target Revenue', type: 'number' },
    {
      name: 'currency', label: 'Currency', type: 'select',
      options: [
        { value: 'KES', label: 'Kenyan Shilling (KES)' },
        { value: 'USD', label: 'US Dollar (USD)' },
        { value: 'EUR', label: 'Euro (EUR)' },
        { value: 'GBP', label: 'British Pound (GBP)' },
        { value: 'TZS', label: 'Tanzanian Shilling (TZS)' },
        { value: 'UGX', label: 'Ugandan Shilling (UGX)' },
        { value: 'ZAR', label: 'South African Rand (ZAR)' },
        { value: 'NGN', label: 'Nigerian Naira (NGN)' },
        { value: 'Other', label: 'Other' },
      ],
    },
    { name: 'timezone_name', label: 'Timezone (e.g. Africa/Nairobi)', type: 'text' },
    { name: 'is_active', label: 'Is Active', type: 'checkbox' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Sales Region' : 'Create Sales Region'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default SalesRegionInput;
